export const planList = [
  {
    title: "Ch1 團隊管理和成員介紹",
    subtitle: "團員相互介紹、成員管理、組織架構與規劃",
    tasktext:
      "完成組隊以後，你們是否已經準備好要一起進行腦力激盪，一起共同走完這學期的壓力測試？第一個章節，我們首要面臨的是團隊組建，請根據你們在課堂上所學的知識用於實務練習，在這個章節，我們將需要你們完成以下事項：\n\n" +
      "1. 請把自己的團隊當成一個公司組織，寫下你們的團隊介紹以及組織架構。\n" +
      "2. 分配各項任務給團隊成員，大家一同協力完成。\n" +
      "3. 將這些內容整理成章節，並把網址貼到下方連結。\n" +
      "4. 點選確認完成，成功繳交本章內容。\n\n" +
      "左邊是一些可參考的文件，如果遇到瓶頸，除了詢問助教外，可以點進去參考看看該如何實作！",
    referList: [
      {
        text: "點子迷宮",
        link: "https://cdixon.org/2013/08/04/the-idea-maze",
      },
      {
        text: "在所有錯的地方尋找愛",
        link: "https://review.firstround.com/Looking-for-Love-in-All-The-Wrong-Places-How-to-Find-a-Co-Founder",
      },
      {
        text: "G Suite",
        link: "https://workspace.google.com/",
      },
      {
        text: "16 personality",
        link: "https://www.16personalities.com/",
      },
    ],
  },
  {
    title: "Ch1.5 SUSU意見調查",
    subtitle: "經過第一章節後，您認為SUSU平台有什麼可以改進的地方嗎？",
    surveylink: "https://forms.gle/C8JWNuaoY1gs89vG8",
  },
  {
    title: "Ch2 公司介紹",
    subtitle: "公司整體概述、公司願景、公司目標、公司企劃",
    tasktext:
      "順利開啟了第一章節的旅程之後，到了第二章節，我們將要面臨一個新的挑戰！在這個章節，你們一樣需要完成幾項任務：\n\n" +
      "1. 請定義公司的願景、目標，並發想團隊未來想要致力於的產業終有什麼可以被解決的問題。\n" +
      "2. 分配各項任務給團隊成員，大家一同協力完成。\n" +
      "3. 將這些內容整理成章節，並把網址貼到下方連結。\n" +
      "4. 點選確認完成，成功繳交本章內容。\n\n" +
      "左邊是一些可參考的文件，如果遇到瓶頸，除了詢問助教外，可以點進去參考看看該如何實作！",
    referList: [
      {
        text: "品牌名稱產生器",
        link: "https://namelix.com",
      },
      {
        text: "品牌名稱測試",
        link: "https://www.linkedin.com/pulse/why-companies-must-test-brand-names-lisa-bertelsen/",
      },
      {
        text: "讓公司看起來更像大品牌的策略",
        link: "https://review.firstround.com/this-brand-strategy-can-make-your-startup-look-bigger-than-it-is",
      },
    ],
  },
  {
    title: "Ch3 市場機會與市場調查",
    subtitle: "產業規模、市場定位與細分、整體行業分析",
    tasktext:
      "在寫完公司願景之後，團隊對於目標有了一致的想法。接下來，你們將要著手挑戰現實市場。在這個章節，你們需要完成幾項任務：\n\n" +
      "1. 請針對任一團隊成員皆感興趣的領域，透過文獻調查，挖掘痛點。\n" +
      "2. 分配各項任務給團隊成員，大家一同協力完成。\n" +
      "3. 將這些內容整理成章節，並把網址貼到下方連結。\n" +
      "4. 點選確認完成，成功繳交本章內容。\n\n" +
      "左邊是一些可參考的文件，如果遇到瓶頸，除了詢問助教外，可以點進去參考看看該如何實作！",
    referList: [
      {
        text: "4P",
        link: "https://blog.gogopartners.com/%E8%A1%8C%E9%8A%B74p-%E8%A1%8C%E9%8A%B7%E7%B5%84%E5%90%88",
      },
      {
        text: "5W2H",
        link: "https://mjitec.com/blog/marketing/%E5%96%84%E7%94%A8%E3%80%8C5w1h%E3%80%8D%EF%BC%8C%E5%AF%AB%E6%96%B0%E8%81%9E%E7%A8%BF%E3%80%81%E7%B6%B2%E7%AB%99%E4%BC%81%E5%8A%83%E3%80%81seo%E7%B6%B2%E7%AB%99%E5%84%AA%E5%8C%96%E5%88%B0/",
      },
      {
        text: "STP",
        link: "https://www.seoseo.com.tw/article_detail_516.html",
      },
    ],
  },
  {
    title: "Ch4 產品策略與競爭者",
    subtitle: "產品構想與策略、競爭者分析",
    tasktext:
      "市場調查之後，團隊是否蒐集到了許多有用的資訊呢？在這個過程中，你們可能發現現又的市場，其實還有許多可以改善的問題，而這個問題，可能就是你們的“痛點”。\n\n" +
      "1. 請團隊成員聚到一起，進行一次頭腦風暴，發想出你們的產品，並解釋此項產品為什麽能成為解決你們在上一章所發現的痛點。\n" +
      "2. 分析你們的競爭者，對產品的策略有什麼影響？\n" +
      "3. 分配各項任務給團隊成員，大家一同協力完成。\n" +
      "4. 將這些內容整理成章節，並把網址貼到下方連結。\n" +
      "5. 點選確認完成，成功繳交本章內容。\n\n" +
      "左邊是一些可參考的文件，如果遇到瓶頸，除了詢問助教外，可以點進去參考看看該如何實作！",
    referList: [
      {
        text: "產品原型",
        link: "https://www.figma.com",
      },
      {
        text: "MVP的終極策略",
        link: "https://hackernoon.com/the-ultimate-guide-to-minimum-viable-product-59218ce738f8",
      },
      {
        text: "競爭者分析",
        link: "https://www.shopify.com/blog/competitive-analysis",
      },
    ],
  },
  {
    title: "Ch5 市場策略與風險",
    subtitle: "初期市場行銷策略、品牌推廣、市場風險",
    menutitle: "Marketingpage",
    referList: [
      {
        text: "市場行銷",
        link: "https://www.pmtone.com/diffusion-of-innovation-theory-2/",
      },
      {
        text: "MVP行銷術",
        link: "https://leanstartup.co/a-crash-course-in-minimum-viable-marketing/",
      },
      {
        text: "以社群為中心的產品設計",
        link: "https://leanstartup.co/how-to-build-a-community-centered-product/",
      },
      {
        text: "如何建立死忠粉絲",
        link: "​​https://medium.com/swlh/how-to-build-a-community-that-loves-you-b6c055361f65",
      },
    ],
    chapterDescription: " ",
    chapterActivity: " ",
  },
  {
    title: "Ch6 商業策略與收入模型",
    subtitle: "商業模型分析、收入模型、財務支出分析",
    menutitle: "LeanCanvaspage",
    referList: [
      {
        text: "商業模式九宮格",
        link: "https://sanyabin.com/business-model-canvas/",
      },
      {
        text: "收入模型概述",
        link: "https://kknews.cc/zh-tw/news/3qagg3o.html",
      },
    ],
    chapterDescription: " ",
    chapterActivity: " ",
  },
  {
    title: "Ch7 財務報表與五年期財務計畫",
    subtitle: "五年財務預測、會計四大報表",
    menutitle: "Stockpage",
    referList: [
      {
        text: "財務預測方法",
        link: "https://www.trustmei.com.tw/single-post/2017/06/30/%E8%B2%A1%E5%8B%99%E9%A0%90%E6%B8%AC%E6%96%B9%E6%B3%95%E4%B9%8B%E4%BB%8B%E7%B4%B9",
      },
      {
        text: "四大報表",
        link: "https://ccinvest.com.tw/4reports/",
      },
    ],
    chapterDescription: " ",
    chapterActivity: " ",
  },
  {
    title: "Ch8 營運資金需求和出場計畫",
    subtitle: "營運資金需求、損益平衡、出場策略",
    menutitle: "Investorpage",
    referList: [
      {
        text: "營運資金需求",
        link: "https://agicap.com/en/article/working-capital-requirement-wcr/",
      },
      {
        text: "損益平衡",
        link: "https://www.managertoday.com.tw/books/view/53450",
      },
      {
        text: "出場策略",
        link: "https://www.investopedia.com/terms/e/exitstrategy.asp ",
      },
    ],
    chapterDescription: " ",
    chapterActivity: " ",
  },
  {
    title: "Ch9 募資計畫",
    subtitle: "預計募資金額、公司價值估算",
    menutitle: "Fundraisingpage",
    referList: [
      {
        text: "種子輪指南",
        link: "https://www.ycombinator.com/blog/how-to-raise-a-seed-round/ ",
      },
      {
        text: "cap table",
        link: "​​https://cornerstonevc.tw/vc-101-what-is-cap-table/ ",
      },
      {
        text: "不要聽這些募資指南",
        link: "https://a16z.com/2018/10/18/fundraising-advice-to-avoid/ ",
      },
      {
        text: "如何了解募資",
        link: "https://a16z.com/2018/10/18/fundraising-advice-to-avoid/ ",
      },
      {
        text: "募資前要做的事",
        link: "https://bothsidesofthetable.com/planning-your-fund-raising-measure-twice-cut-once-1c6211346b5  ",
      },
    ],
    chapterDescription: " ",
    chapterActivity: " ",
  },
  {
    title: "Ch10 總結",
    subtitle: "商業計劃書結論、CEO總結、網站製作",
    menutitle: "Conclusion",
    referList: [
      {
        text: "Logodust",
        link: "https://www.logodust.com/ ",
      },
      {
        text: "Fiverr",
        link: "https://www.fiverr.com/ ",
      },
      {
        text: "f99design",
        link: "https://99designs.com/ ",
      },
      {
        text: "Canva",
        link: "https://www.canva.com/  ",
      },
      {
        text: "Pinterest",
        link: "https://www.pinterest.com/  ",
      },
      {
        text: "Behance",
        link: "https://www.behance.net/  ",
      },
      {
        text: "Venngage",
        link: "https://venngage.com/features/poster-maker ",
      },
      {
        text: "Adobe Premiere",
        link: "https://www.adobe.com/tw/products/premiere/free-trial-download.html   ",
      },
      {
        text: "Google 協作平台",
        link: "https://sites.google.com/new?hl=zh-TW ",
      },
      {
        text: "Ｗix",
        link: "https://zh.wix.com/   ",
      },
      {
        text: "Wordpress",
        link: "https://wordpress.com/   ",
      },
    ],
    chapterDescription: " ",
    chapterActivity: " ",
  },
  // {
  //   title: "Ch11 網站製作",
  //   subtitle: "將商業企劃書轉化成公司呈現介面",
  //   menutitle: "WebMaking",
  //   referList: [],
  //   chapterDescription: " ",
  // },
];
